import React, { useEffect, useState } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { createStructuredSelector } from 'reselect';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import {
  COMPONENT_NAME,
  FILTER_SECTION,
  FILTEREEDLIST_SECTION,
} from './locators';
import Grid from '../../../components/molecules/Grid';
import useStyles from './style';
import FilteredList from '../FilteredList';
import { filteredData } from '../ListingSubLayout/selectors';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { getComponentName } from '../../../utils/getPageComponentInfo';
import { pageContentType } from '../../../utils/getContentType';
import { getFilterdInfoData } from '../Filters/redux/actions';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getCurrentLanguage } from '../../../utils/getCurrentLanguage';
import { canUseDOM } from '../../../utils/canUseDOM';
import ADLiting from '../../../components/organism/ADListing/ADListing'
import clsx from 'clsx';

const BannerWithEventFilterSubLayout = (props) => {
  let solrPayloadToFetchFilter = {};
  const language = getCurrentLanguage(props);
  const classes = useStyles();
  const contentType = pageContentType(props).toLowerCase();
  const titleHeading = get(props, 'fields.Heading.value', 'in Abu Dhabi')
  const isFilteredDataAvailable = Boolean(get(props, 'filteredData.data.results'));

  const payloadForListingCall = () => {
    solrPayloadToFetchFilter.contentType = contentType;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    solrPayloadToFetchFilter.limit = Number(getDictionaryText('attributePageLoadCount'));
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];
    return solrPayloadToFetchFilter;
  };

  useEffect(() => {
    const payload = payloadForListingCall();
    props.getFilterdInfoData({
      apiUrl: `${props.appConfig.SOLR_FILTERS_DATA}`,
      payload: payload,
    });
  }, []);

  // Rohan's work //
  const [filterOpen, setFilterOpen] = useState(false)
  const createSVG = (type = '', fill = '', customClass = '') => {
    switch (type) {
      case 'filter':
        return (
          <svg className={customClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.2012" cy="10" r="2" stroke="white" stroke-width="2" />
            <circle cx="4.20117" cy="6" r="2" transform="rotate(180 4.20117 6)" stroke="white" stroke-width="2" />
            <rect x="11.2012" y="12" width="2" height="3" rx="1" fill="white" />
            <rect x="5.20117" y="4" width="2" height="3" rx="1" transform="rotate(180 5.20117 4)" fill="white" />
            <rect x="11.2012" y="1" width="2" height="7" rx="1" fill="white" />
            <rect x="5.20117" y="15" width="2" height="7" rx="1" transform="rotate(180 5.20117 15)" fill="white" />
          </svg>
        )
        break;
      case 'cross':
        return (
          <svg className={customClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L10 10M2 10L10 2" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>
        )
        break;
        return <></>
    }
  }
  return (
    <>
      <Grid
        item
        className={clsx(classes.listingLayoutWrappeer, 'listingPageWrapper')}
        data-locator={COMPONENT_NAME}
      >

        <Grid
          item
          className={classes.filterSection}
          data-locator={FILTER_SECTION}
        >
          <Placeholder name="vad-filters" titleHeading={titleHeading} filterOpen={filterOpen} rendering={props.rendering} appConfig={props.appConfig} />
        </Grid>
        {isFilteredDataAvailable && (
          <Grid
            item
            className={`${classes.filterdList} sty2`}
            data-locator={FILTEREEDLIST_SECTION}
            aria-live="polite"
          >
            <FilteredList isEventCard={true} componentName={getComponentName(props)} appConfig={props.appConfig} />
          </Grid>
        )}
      </Grid>
    </>
  )
};

export const mapDispatchToProps = dispatch => {
  return {
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
  };
};

export const mapStateToProps = createStructuredSelector({
  filteredData: filteredData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BannerWithEventFilterSubLayout))
  )
);